// All scripture text goes through the `scripturePassage` Cloud Function,
// which holds the api.bible key server-side so it isn't exposed in the site.
const PROJECT_ID = process.env.REACT_APP_FIREBASE_PROJECT_ID;
const PROXY_URL =
  process.env.REACT_APP_SCRIPTURE_PROXY_URL ||
  `https://us-central1-${PROJECT_ID}.cloudfunctions.net/scripturePassage`;

// Returns the passage HTML ('' if the passage has no content).
export async function fetchPassageHtml(passageId, options = {}) {
  const params = new URLSearchParams({ id: passageId, ...options });
  const res = await fetch(`${PROXY_URL}?${params}`);
  if (!res.ok) throw new Error(`Scripture request failed (${res.status})`);
  const data = await res.json();
  return data.data?.content || '';
}
